import script from "./WaizmannWertBrille.vue?vue&type=script&setup=true&lang=js"
export * from "./WaizmannWertBrille.vue?vue&type=script&setup=true&lang=js"

import "./WaizmannWertBrille.vue?vue&type=style&index=0&id=268eb1c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268eb1c2"]])

export default __exports__